/* Stylesheet */

.bullet {
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background: #d9e1f2;
  transition: 0.25s ease-in-out;

  &.active {
    height: 12px;
    width: 12px;
    background: var(--ion-color-primary);
  }
}
